/**
 * Phase 7+ NO-OP component.
 *
 * Background: this used to render <title>, <meta>, <link> via JSX so
 * react-helmet-async could pick them up. After we migrated to React 19
 * + native head hoisting and removed react-helmet-async, both the static
 * tags in public/index.html (and prerendered detail HTML) AND React 19's
 * auto-hoisted JSX tags ended up in <head>, which is exactly what Bing
 * Webmaster flagged as "more than one title / description / canonical".
 *
 * The single source of truth is now:
 *   • public/index.html      → defaults for the home shell
 *   • scripts/generate-sitemap.js → per-entity prerendered HTML (stories,
 *                                   podcast, events, resources)
 *
 * SPA route changes still update document.title imperatively via the
 * `useDocumentTitle` hook below so visitors see correct tab labels when
 * navigating client-side; that hook touches only document.title (it
 * never creates new <title> elements).
 */
import { useEffect } from "react";

const SITE_NAME = "Mujeres Motor";

export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title || typeof document === "undefined") return;
    const full = title.includes(SITE_NAME) ? title : `${title} — ${SITE_NAME}`;
    const previous = document.title;
    document.title = full;
    return () => { document.title = previous; };
  }, [title]);
}

export default function SEO({ title }) {
  // Imperatively update document.title on SPA navigation; never render
  // any JSX so React 19 has nothing to hoist into <head>.
  useDocumentTitle(title);
  return null;
}
